import React, { createContext, useContext, ReactNode } from 'react';
import { ReportingPeriodFilter } from './_types';
import { getDateRangeFromFilter } from '../../components/ReportingPeriodPicker';

export interface QueryParams {
  startDate: string;
  endDate: string;
}

interface TrainingContextValue {
  queryParams: QueryParams;
}

const TrainingContext = createContext<TrainingContextValue | undefined>(undefined);

interface TrainingProviderProps {
  children: ReactNode;
  periodFilter: ReportingPeriodFilter;
}

export function TrainingProvider({ children, periodFilter }: TrainingProviderProps) {
  const { startDate, endDate } = getDateRangeFromFilter(periodFilter);

  const queryParams: QueryParams = {
    startDate,
    endDate,
  };

  return <TrainingContext.Provider value={{ queryParams }}>{children}</TrainingContext.Provider>;
}

export function useTrainingContext(): TrainingContextValue {
  const context = useContext(TrainingContext);
  if (context === undefined) {
    throw new Error('useTrainingContext must be used within a TrainingProvider');
  }
  return context;
}
